/**
 * Extract error message từ Axios error response theo chuẩn API: { success, message, data, errors }
 *
 * @param {Error|AxiosError|string} error
 * @param {string} fallback
 * @returns {string}
 */
export function extractErrorMessage(error, fallback = 'Có lỗi xảy ra') {
    if (!error) return fallback;

    if (typeof error === 'string') return error;

    const beMessage = error?.response?.data?.message;
    if (beMessage && typeof beMessage === 'string') return beMessage;

    const beErrors = error?.response?.data?.errors;
    if (beErrors && typeof beErrors === 'object') {
        const firstError = Object.values(beErrors).flat()[0];
        if (firstError) return firstError;
    }

    if (error.message && typeof error.message === 'string') return error.message;

    return fallback;
}
